export class Item {
    public readonly id!: string;
    public readonly name!: string;
    public readonly code!: string;
}
